export function audioManager() {
	let currentAudioSource: MediaElementAudioSourceNode;
	let dataArray: Float32Array<ArrayBuffer> | undefined;
	let analyser: AnalyserNode | undefined;
	let audioContext: AudioContext | undefined;

	function startAudio() {
		const connected = createAnalyser();
		dataArray = connected.dataArray;
		analyser = connected.analyser;
		audioContext = connected.audioContext;
	}

	function createAnalyser() {
		const audioContext = new window.AudioContext();
		const analyser = audioContext.createAnalyser();
		analyser.fftSize = 2048;
		const bufferLength = analyser.frequencyBinCount;
		const dataArray = new Float32Array(bufferLength);
		analyser.connect(audioContext.destination);
		return { analyser, dataArray, audioContext };
	}

	function getDataArray(): number[] {
		if (analyser && dataArray) {
			analyser.getFloatTimeDomainData(dataArray);
			return [...dataArray];
		} else {
			return [];
		}
	}

	function connectToAnalyser(audioElement: HTMLAudioElement) {
		if (audioContext !== undefined && analyser !== undefined) {
			try {
				const newCurrentAudioSource = audioContext.createMediaElementSource(audioElement);
				currentAudioSource = newCurrentAudioSource;
				currentAudioSource.connect(analyser);
			} catch (e) {
				console.error(e);
			}
		}
	}

	return {
		connectToAnalyser,
		getDataArray,
		startAudio
	};
}

export type AudioPartialData = {
	media_url: string;
	mute: boolean;
	noCrossOrigin?: boolean;
};

export function createAudioElement(data: AudioPartialData) {
	const audio = document.createElement('audio');
	if (!data.noCrossOrigin) {
		audio.crossOrigin = 'anonymous';
	}
	audio.src = data.media_url;
	audio.muted = data.mute;
	return audio;
}
